export default __webpack_public_path__ + "static/media/woo-woo, soothing.ca594caa.jpg";